<template>
    <select v-model="value" @change="emitChange" class="floating-select">
      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>
</template>
  
<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      initialValue: {
        required: false,
        default: "",
      },
      options: {
        type: Array,
        required: true,
      },

    },
    data() {
      return {
        value: this.initialValue,
      };
    },
    methods: {
      emitChange() {
        this.$emit("handle-change", { value: this.value, name: this.name });
      },
    },
    watch: {
      initialValue: {
        immediate: true,
        handler(newValue) {
          this.value = newValue;
        },
      },
    },
  };
</script>
  
<style lang="scss" scoped>
.floating-select {
  width: 100%;
  height: 44px;
  padding: 0 15px;
  border: 1px solid #a5a9ad;
  border-radius: 4px;
  background: transparent;
  color: black;
  font-size: 14px;
  appearance: none; 
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black' width='20px' height='20px'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center; 
  background-size: 20px;
  padding-right: 35px;

  &:hover {
    border: 2px solid #a5a9ad;
    border-radius: 4px;

  }
}

.floating-select:focus {
  border: 1px solid #a5a9ad;
  outline: none;
}

</style>
  